import MainFrame from "../../components/mainFrame";
import { Box, Button, IconButton } from "@mui/material";
import styled from "@emotion/styled";
import StickyTable from "../../components/table";
import Navbar from "../../components/navbar";
import { Cell } from "../../components/table/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import { useModal } from "../../components/modal";
import { DeleteModal } from "../../components/appbar/modal";
import { smallButton } from "../../components/Button";
import AddModal from "./modal";
import { Helmet } from "react-helmet";

const Container = styled(Box)({
  padding: "1rem",
  width: "100%",
  height: "100%",
  minHeight: "90vh",
  maxHeight: "90vh",
});

function DiscountCodes() {
  const { setShow, setContent } = useModal();
  function handleOpenModal(type: string) {
    if (type === "edit") {
      setContent({
        title: " ویرایش کد تخفیف ",
        body: <AddModal />,
      });
    }
    if (type === "add") {
      setContent({
        title: " افزودن کد تخفیف ",
        body: <AddModal />,
      });
    }
    if (type === "delete") {
      setContent({
        title: "حذف کد تخفیف ",
        body: <DeleteModal handleDelete={() => console.log("delete")} />,
      });
    }
    setShow(true);
  }
  return (
    <Container bgcolor="primary.light">
      <Helmet>
        <title> کدتخفیف ها | پنل ادمین yaadin</title>
      </Helmet>
      <Navbar title="کد تخفیف ها">
        <Button
          onClick={() => handleOpenModal("add")}
          sx={[
            smallButton,
            {
              color: "divider",
              borderColor: "divider",
              borderStyle: "solid",
              borderWidth: "1px",
            },
          ]}
        >
          <AddIcon />
          افزودن کدتخفیف
        </Button>
      </Navbar>
      <StickyTable
        headers={[
          { name: "شناسه کوپن" },
          { name: "مقدار" },
          { name: "توضیحات" },
        ]}
        // rows={[{}, {}]}
        length={0}
        operations={true}
      >
        <Cell width="30%"></Cell>
        <Cell></Cell>
        <Cell></Cell>
        <Cell
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <IconButton onClick={() => handleOpenModal("edit")}>
            <EditIcon sx={{ color: "divider" }} />
          </IconButton>
          <IconButton onClick={() => handleOpenModal("delete")}>
            <DeleteIcon sx={{ color: "divider" }} />
          </IconButton>
        </Cell>
      </StickyTable>
    </Container>
  );
}

export default MainFrame(DiscountCodes);
